import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@good/ui/core';
import { Compass } from '@good/icons';

export const AllViewsButton = () => {
  const history = useHistory();
  const goBookingAllViews = () => {
    history.push('/bookings/all-views');
  };

  return (
    <Button variant='default' leftSection={<Compass />} onClick={goBookingAllViews}>
      Manage
    </Button>
  );
};
